'use client';

import { Skeleton } from '@/components/ui/skeleton';
import { Separator } from '@/components/ui/separator';

export function ProjectDetailSheetSkeleton() {
  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="px-6 pt-5 pb-0 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0 flex-1 space-y-2">
            {/* Title (2 lines) */}
            <Skeleton className="h-5 w-full" />
            <Skeleton className="h-5 w-3/4" />
            {/* Subtitle */}
            <Skeleton className="h-4 w-1/2" />
          </div>
        </div>

        {/* Badge row */}
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-5 w-16 rounded-full" />
          <Skeleton className="h-5 w-20 rounded-full" />
          <Skeleton className="h-5 w-24 rounded-full" />
          <Skeleton className="h-5 w-12 rounded-full" />
        </div>
      </div>

      {/* Primary actions row */}
      <div className="px-6 pt-4 pb-1">
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-8 w-36 rounded-md" />
          <Skeleton className="h-8 w-28 rounded-md" />
          <Skeleton className="h-8 w-24 rounded-md" />
        </div>
      </div>

      <Separator className="my-4 mx-6 w-auto" />

      {/* Content sections */}
      <div className="px-6 space-y-6 flex-1">
        {/* Executive Summary */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-36" />
          <div className="space-y-2">
            <Skeleton className="h-3.5 w-full" />
            <Skeleton className="h-3.5 w-full" />
            <Skeleton className="h-3.5 w-full" />
            <Skeleton className="h-3.5 w-2/3" />
          </div>
        </div>

        <Separator />

        {/* Timeline */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-20" />
          <div className="space-y-1.5">
            <div className="grid grid-cols-2 gap-4">
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-4 w-24" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Skeleton className="h-4 w-20" />
              <Skeleton className="h-4 w-24" />
            </div>
          </div>
        </div>

        <Separator />

        {/* Utility buttons */}
        <div className="flex flex-wrap gap-2">
          <Skeleton className="h-8 w-32 rounded-md" />
          <Skeleton className="h-8 w-32 rounded-md" />
        </div>

        {/* Provenance accordion */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
        </div>
      </div>

      <div className="h-6" />
    </div>
  );
}
